<template>
  <footer
    class="site-footer"
    :class="{
      'site-footer--slim': standardVariant === 'slim',
      'site-footer--standard-only': showStandard && !showSeo,
      'site-footer--mobile-pad': mobileBottomPad,
    }"
  >
    <div v-if="showStandard" class="site-footer__main">
      <div class="container">
        <div class="site-footer__about" :class="{ 'site-footer__about--compact': standardVariant === 'slim' }">
          <h2 class="site-footer__about-title">{{ aboutContent.title }}</h2>
          <p
            v-for="(paragraph, index) in aboutContent.paragraphs"
            :key="index"
            class="site-footer__about-text"
          >{{ paragraph }}</p>
        </div>

        <div class="site-footer__zones site-footer__zones--full">
          <div
            v-for="zone in zones"
            :key="zone.id"
            class="site-footer__zone"
          >
            <h4 class="site-footer__zone-title">{{ zone.title }}</h4>
            <ul class="site-footer__zone-list">
              <li v-for="(link, index) in zone.links" :key="`${zone.id}-${index}`">
                <a
                  :href="link.href"
                  class="site-footer__zone-link"
                  :target="link.external ? '_blank' : undefined"
                  :rel="link.external ? 'noopener' : undefined"
                >
                  {{ link.label }}
                  <v-icon
                    v-if="link.featured"
                    class="site-footer__zone-featured"
                    size="14"
                  >{{ $icons.starCircle }}</v-icon>
                </a>
              </li>
              <li v-if="zone.phone" class="site-footer__zone-phone">{{ zone.phone }}</li>
              <li v-if="zone.cta">
                <a :href="zone.cta.href" class="hp-btn hp-btn--outline site-footer__zone-cta">
                  {{ zone.cta.label }}
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>

    <div v-if="showSeo" class="site-footer__seo">
      <div class="container">
        <FooterSeoSection
          v-for="section in FOOTER_SEO_SECTIONS"
          :key="section.id"
          :section="section"
        />
      </div>
    </div>

    <div class="site-footer__bottom">
      <div class="container site-footer__bottom-inner">
        <p class="site-footer__copy">© {{ year }} Talentmap Technologies Pvt Ltd</p>
        <div class="site-footer__legal">
          <a href="/privacy" rel="noopener">Privacy Policy</a>
          <span class="site-footer__legal-sep" aria-hidden="true">·</span>
          <a href="/terms" rel="noopener">Terms &amp; Conditions</a>
        </div>
        <div class="site-footer__social">
          <a
            v-for="item in FOOTER_SOCIAL"
            :key="item.icon"
            :href="item.href"
            :aria-label="item.label"
            class="site-footer__social-link"
            target="_blank"
            rel="noopener"
          >
            <v-icon size="20">{{ $icons[item.icon] }}</v-icon>
          </a>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
import FooterSeoSection from '@/components/chrome/FooterSeoSection.vue';
import {
  FOOTER_ABOUT_FULL,
  FOOTER_ABOUT_SLIM,
  FOOTER_ZONES_FULL,
  FOOTER_ZONES_SLIM,
  FOOTER_SEO_SECTIONS,
  FOOTER_SOCIAL,
} from '@/constants/footerLinks';

import '@/assets/home-page.css';
import '@/assets/site-chrome.css';

export default {
  name: 'SiteFooter',
  components: { FooterSeoSection },
  props: {
    showStandard: { type: Boolean, default: true },
    showSeo: { type: Boolean, default: true },
    standardVariant: {
      type: String,
      default: 'full',
      validator: value => ['full', 'slim'].includes(value),
    },
    mobileBottomPad: { type: Boolean, default: false },
  },
  data() {
    return {
      FOOTER_SEO_SECTIONS,
      FOOTER_SOCIAL,
      year: new Date().getFullYear(),
    };
  },
  computed: {
    aboutContent() {
      return this.standardVariant === 'slim' ? FOOTER_ABOUT_SLIM : FOOTER_ABOUT_FULL;
    },
    zones() {
      return this.standardVariant === 'slim' ? FOOTER_ZONES_SLIM : FOOTER_ZONES_FULL;
    },
  },
};
</script>
